import ApplicationAdapter from 'cio/adapters/application';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import { ModelRegistry } from 'ember-data/model';
import DS from 'ember-data';

/* eslint-disable */
export default class IntegrationsDataOutAdapter extends ApplicationAdapter {
  @service environment!: EnvironmentService;

  // Build URLs in the format: /v1/environments/:id/integrations/data_out/:type
  buildURL<K extends keyof ModelRegistry>(
    modelName?: K,
    id?: string,
    snapshot?: DS.Snapshot<K> | any[] | null,
    requestType?: string,
    query?: {},
  ): string {
    let integrationType = (snapshot as any).adapterOptions.type;

    if (!integrationType) {
      throw new Error('`snapshot.adapterOptions.type` must be defined before making a request to fetch an integration');
    }

    if (!this.environment.current.id) {
      throw new Error('`environment` needs to be initialized before making a request to fetch an integration');
    }

    return `${this.host}/${this.namespace}/environments/${this.environment.current.id}/integrations/data_out/${integrationType}`;
  }
}
